import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import useModularPDPCart from 'data-hooks/useModularPDPCart';
import { getPriceDetailsUtil } from 'data-hooks/utils';
import usePdpIsModularBYOProduct from 'components/consumer/PDP/state/context/usePdpIsModularBYOProduct';
import usePDPPrice from 'data-hooks/usePDPPrice';
const usePDPTieredPrice = (t0, t1, t2, t3, t4) => {
  const $ = _c(20);
  const priceObj = t0 === undefined ? null : t0;
  const promotion = t1 === undefined ? null : t1;
  const optionPrice = t2 === undefined ? 0 : t2;
  const productId = t3 === undefined ? null : t3;
  const slug = t4 === undefined ? null : t4;
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const productPriceData = usePDPPrice(productId, slug);
  let t5;
  if ($[0] !== priceObj || $[1] !== productPriceData) {
    t5 = priceObj ? {
      loading: false
    } : productPriceData;
    $[0] = priceObj;
    $[1] = productPriceData;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const {
    data: t6,
    loading
  } = t5;
  let t7;
  if ($[3] !== t6) {
    t7 = t6 === undefined ? {} : t6;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const priceData = t7;
  const {
    data: modularCartData
  } = useModularPDPCart(productId, slug);
  modularCartData?.modularTotalPrice;
  let t8;
  bb0: {
    if (priceObj) {
      let t9;
      if ($[5] !== optionPrice || $[6] !== priceObj || $[7] !== promotion) {
        t9 = getPriceDetailsUtil(priceObj, promotion, optionPrice, false);
        $[5] = optionPrice;
        $[6] = priceObj;
        $[7] = promotion;
        $[8] = t9;
      } else {
        t9 = $[8];
      }
      t8 = t9;
      break bb0;
    }
    if (!priceData) {
      let t9;
      if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {};
        $[9] = t9;
      } else {
        t9 = $[9];
      }
      t8 = t9;
      break bb0;
    }
    if (pdpIsModularBYOProduct) {
      const t9 = modularCartData?.modularTotalPrice;
      let t10;
      if ($[10] !== t9) {
        t10 = {
          priceWithOptionsPrice: t9
        };
        $[10] = t9;
        $[11] = t10;
      } else {
        t10 = $[11];
      }
      t8 = t10;
      break bb0;
    }
    const t9 = priceData?.price;
    const t10 = priceData?.promotion;
    const t11 = priceData?.optionPrice;
    const t12 = priceData?.isClearance;
    let t13;
    if ($[12] !== t10 || $[13] !== t11 || $[14] !== t12 || $[15] !== t9) {
      t13 = getPriceDetailsUtil(t9, t10, t11, t12);
      $[12] = t10;
      $[13] = t11;
      $[14] = t12;
      $[15] = t9;
      $[16] = t13;
    } else {
      t13 = $[16];
    }
    t8 = t13;
  }
  const priceDetails = t8;
  let t9;
  if ($[17] !== loading || $[18] !== priceDetails) {
    t9 = {
      loading,
      priceDetails
    };
    $[17] = loading;
    $[18] = priceDetails;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default usePDPTieredPrice;